module.exports = __webpack_public_path__ + "media/מתנות.3f26a789.mp3";